import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useGiftStore = defineStore("gift", {
  state: () => {
    return {
      gifts: [],
    };
  },
});

export const storeGift = useGiftStore(pinia);
